import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BlogListComponent } from './blog-list/blog-list.component';
import { BlogDetailsComponent } from './blog-details/blog-details.component';
import { Routes, RouterModule } from '@angular/router';
import { CommonSharedModule } from '../../../shared/shared.module';
import routeTable from '../../../utility/routeTable';

const routes: Routes = [
  { path: '', component: BlogListComponent },
  { path: routeTable.public.blogDetail, component: BlogDetailsComponent },
]


@NgModule({
  declarations: [
    BlogListComponent, BlogDetailsComponent,
  ],
  imports: [
    CommonModule,
    CommonSharedModule,
    RouterModule.forChild(routes),
  ],
})
export class BlogModule { }
